import React, { useContext, useEffect, useState } from 'react';
import ArrowLeft from '../../../../../Assets/Arrow left.svg';
import Cross from '../../../../../Assets/Modals/closeIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, selectTagListProduct, setEditSection, setVideo, setVideoPostMenu, toggleTagList, closeTagList, pushToFeedPosts } from '../../../../../Features/lensSlice';
import Tag from '../../../../../Assets/Lens/tagIcon.svg';
import TagList from '../../TagList';
import Discard from '../../../../../Assets/Lens/Discard.svg';
import { VideoContext } from '../../../../../Context/VideoContext';
import { getVideoUrl } from '../../../../../lib/utils/utils';
import { createPost } from '../../../../../lib/utils/apiCalls';
import { showToast } from '../../../../../Components/Toaster/Toaster';
import './videoToast.css';

import { fetchFile } from '@ffmpeg/util';
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { toast } from 'react-toastify';

let ffmpeg; //Store the ffmpeg instance here

function VideoPostForm() {
    const dispatch = useDispatch();

    const taggedProduct = useSelector((state) => state.lens.tagList.product);

    const { videoFile } = useContext(VideoContext);

    const defaultFormErrors = {
        title: '',
        description: '',
    };

    const [formErrors, setFormErrors] = useState(defaultFormErrors);

    const defaultFormFields = {
        title: '',
        description: '',
    };

    const [formFields, setFormFields] = useState(defaultFormFields);

    const [isScriptLoaded, setIsScriptLoaded] = useState(false);

    const handleCloseModal = () => {
        dispatch(closeModal());
        dispatch(setVideo(null));
        dispatch(setEditSection(null));
        dispatch(setVideoPostMenu('edit'));
        dispatch(selectTagListProduct(taggedProduct));
        dispatch(closeTagList());
    }

    const handlePreviousClick = () => {
        dispatch(setVideoPostMenu('edit'));
        dispatch(selectTagListProduct(taggedProduct));
        dispatch(closeTagList());
    }

    const handleTagButton = () => {
        dispatch(toggleTagList());
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormFields({...formFields, [name]: value});
    }

    const handleRemoveTaggedProduct = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(selectTagListProduct(taggedProduct));
    }

    const handlePublishPost = async () => {
        const validationErrors = {};
    
        if (!formFields.title.trim()) {
            validationErrors.title = 'Please enter a title';
        }
    
        if (!formFields.description.trim()) {
            validationErrors.description = 'Please enter a caption';
        }
        else if (formFields.description.trim().length > 255) {
            validationErrors.description = 'Max 255 characters';
        }
    
        if (Object.keys(validationErrors).length > 0) {
            setFormErrors(validationErrors);
            return;
        }
    
        setFormErrors(defaultFormErrors);
    
        if (!isScriptLoaded) {
            showToast('Script not loaded! Please wait!', 'warning');
            return;
        }
    
        try {
            handleCloseModal();
            const { type } = videoFile;
            const videoData = await fetchFile(videoFile);
            await ffmpeg.writeFile('video.mp4', videoData);

            const videoFileType = type.split('/')[1];

            const compressPromise = ffmpeg.exec([
                '-i', 'video.mp4',
                '-c:v', 'libx264',
                '-crf', '30',
                '-preset', 'veryfast',
                `out.${videoFileType}`,
            ]);

            toast.promise(
                compressPromise,
                {
                    pending: {
                        render() {
                            return 'Uploading your post...'
                        },
                        className: 'toast-pending',
                    },
                    error: {
                        render() {
                            return 'Something went wrong while uploading your video.'
                        },
                    }
                }
            );

            try {
                await compressPromise;
            }
            catch(err) {
                return;
            }

            const data = await ffmpeg.readFile('out.mp4');
            const compressedBlob = new Blob([data.buffer], { type: 'video/mp4' });
            const compressedFile = new File([compressedBlob], 'output.mp4', { type: 'video/mp4' });
    
            const url = await getVideoUrl(compressedFile);

            const response = await createPost({
                productId: taggedProduct.id,
                postTitle: formFields.title,
                postDesc: formFields.description,
                videoUrls: url,
            });

            if (response?.status === 200) {
                dispatch(pushToFeedPosts(response.data.data));
                showToast('Your video is live.', 'success');
            }
            else {
                showToast('Something went wrong while uploading your video.', 'error');
                return;
            }
        }
        catch (err) {
            showToast('Something went wrong while uploading your video.', 'error');
        }
    };

    useEffect(() => {
        if(taggedProduct.id) {
            const validationErrors = {};

            validationErrors.title = formErrors.title;
            validationErrors.description = formErrors.description;
            validationErrors.taggedProduct = '';

            setFormErrors(validationErrors);
        }
        // eslint-disable-next-line
    }, [taggedProduct.id]);

    useEffect(() => {
        const loadffmpeg = async () => {
            ffmpeg = new FFmpeg();
            await ffmpeg.load({ log: true });
            setIsScriptLoaded(true);
        }

        loadffmpeg();
    }, []);

    return (
        <div className="w-2/5 relative flex flex-col h-full p-4">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <button onClick={handlePreviousClick} className="w-11 h-11 flex items-center justify-center">
                        <img src={ArrowLeft} alt="" />
                    </button>

                    <h1 className='font-semibold text-2xl text-[#121212]'>Video Post</h1>
                </div>

                <button onClick={handleCloseModal} className="w-11 h-11 flex items-center justify-center">
                    <img src={Cross} alt="" />
                </button>
            </div>

            <TagList />

            <div className="flex flex-col gap-4 mt-4 pb-16 overflow-y-scroll no-scrollbar">
                <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between">
                        <label className='font-medium text-base text-[#121212]' htmlFor="title">Post Title</label>

                        {formErrors.title && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.title}</p>}
                    </div>

                    <input 
                        value={formFields.title} 
                        onChange={handleInputChange} 
                        className='outline-none text-[#121212] px-3 py-4 font-normal text-base placeholder:text-[#666666] bg-[#F5F5F5] rounded-[9px] border border-[#EAEAEA] focus:border-primaryColor' 
                        id='title' 
                        placeholder='Add title' 
                        type="text" 
                        name='title' 
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between">
                        <label className='font-medium text-base text-[#121212]' htmlFor="title">Post Description <span className='text-[14px] leading-5 text-[#808080]'>&#40;{formFields.description.length}/255&#41;</span></label>

                        {formErrors.description && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.description}</p>}
                    </div>

                    <textarea 
                        value={formFields.description} 
                        onChange={handleInputChange} 
                        className='h-[240px] outline-none text-[#121212] px-3 py-4 font-normal text-base placeholder:text-[#666666] bg-[#F5F5F5] rounded-[9px] border border-[#EAEAEA] focus:border-primaryColor' 
                        id='description' 
                        placeholder='Write a short description about your brand, product quality...' 
                        type="text" 
                        name='description' 
                    />
                </div>

                <div onClick={handleTagButton} className='bg-[#F5F5F5] cursor-pointer rounded-[9px] p-3 flex items-center gap-1'>
                    <div className="w-6 h-6 flex items-center justify-center">
                        <img src={Tag} alt="" />
                    </div>

                    {
                        taggedProduct.id ? 
                        <p className='w-[calc(100%-48px)] font-normal text-[12px] leading-6 text-[#121212] text-left'>{taggedProduct.name}</p> : 
                        <p className='font-normal text-base text-[#666666]'>tag product</p>
                    }

                    {
                        taggedProduct.id &&
                        <button onClick={handleRemoveTaggedProduct} className="ml-auto w-6 h-6 flex items-center justify-center">
                            <img src={Discard} alt="" />
                        </button>
                    }
                </div>
            </div>

            <div className="absolute bottom-0 left-0 w-full px-4 py-3 bg-[#FFFFFF] border-t border-[#EAEAEA]">
                <button onClick={handlePublishPost} className='w-full px-4 py-[6px] rounded-md bg-primaryColor hover:bg-primaryAccent font-semibold text-[14px] leading-[26px] text-buttonText'>Publish Post</button>
            </div>
        </div>
    );
}

export default VideoPostForm;